const config = {
  API_URL:
    process.env.REACT_APP_API_ENV === "local"
      ? "http://localhost:4000"
      : process.env.REACT_APP_API_ENV === "dev"
        ? "https://dj09ip7fze04p.cloudfront.net"
        : "https://d38rh6rrp7h17w.cloudfront.net",
  MAPBOX_API_TOKEN:
    "pk.eyJ1IjoidGltYnJvZGRpbnZydCIsImEiOiJjamt5MXJ3emUwMW5pM3BuMm5vcjFoeXN6In0.v1YRe_iGRLeQtr-R94Efmw",
  FRONTEND_OPEN: true,
  EMOJI_URL: "https://d3oxc66l2klzec.cloudfront.net",
  FRONTEND_URL:
    process.env.REACT_APP_API_ENV === "local"
      ? "http://localhost:3000"
      : process.env.REACT_APP_API_ENV === "dev"
        ? "https://stag.kieskaart.mnm.be"
        : "https://kieskaart.mnm.be"
};

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js